import Breadcrumb from './src/breadcrumb';
export default Breadcrumb;